import apiWorker from '../apiWorker'

const email_senders = {
    create: (data)          => apiWorker('post',   `/api/v1/automations/email_senders`, data, true),
    update: (_id, data)     => apiWorker('patch',  `/api/v1/automations/email_senders/${_id}`, data, true),
    delete: (_id, data)     => apiWorker('delete', `/api/v1/automations/email_senders/${_id}`, data, true),
    find: (data)            => apiWorker('get',    `/api/v1/automations/email_senders`, null, true),
}

export default email_senders;